export default {
    label: 'Collapsible Text',
    name: 'collapsible_text',
    file: 'src/content/components/collapsibleText.json',
    format: 'json',
    i18n: true,
    create: false,
    fields: [
        {
            label: 'Read More',
            name: 'read_more',
            widget: 'string',
            required: true,
            i18n: true,
        },
        {
            label: 'Read Less',
            name: 'read_less',
            widget: 'string',
            required: true,
            i18n: true,
        },
    ]
}